import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-21fab935"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "lp-card lp-progress" }
const _hoisted_2 = { class: "lp-progress__title" }
const _hoisted_3 = { class: "lp-progress__summary" }
const _hoisted_4 = { class: "lp-progress__ring" }
const _hoisted_5 = {
  viewBox: "0 0 84 84",
  "aria-hidden": "true"
}
const _hoisted_6 = ["stroke-dashoffset"]
const _hoisted_7 = { class: "lp-progress__current" }
const _hoisted_8 = { class: "lp-progress__done" }
const _hoisted_9 = { class: "lp-progress__list" }
const _hoisted_10 = ["onClick"]
const _hoisted_11 = {
  class: "lp-progress__state",
  "aria-hidden": "true"
}
const _hoisted_12 = {
  key: 0,
  class: "bi bi-check-circle-fill"
}
const _hoisted_13 = { class: "lp-progress__name" }
const _hoisted_14 = { class: "lp-progress__count" }

import { computed } from 'vue';
import { ISection, sectionProgress, useLearningPathI18n } from './learningPath';


export default /*#__PURE__*/_defineComponent({
  props: {
    sections: null,
    currentSectionId: null
  },
  emits: ["select"],
  setup(__props: any, { emit }: { emit: ({
  (e: 'select', sectionId: number): void
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  sections: ISection[]
  currentSectionId: number | null
}





const { tl } = useLearningPathI18n();

const RADIUS = 36;
const CIRCUMFERENCE = 2 * Math.PI * RADIUS;

const items = computed(() => props.sections.map((section, index) => ({
  section,
  number: index + 1,
  ...sectionProgress(section),
})));

const completedCount = computed(() => items.value.filter(item => item.completed).length);
const total = computed(() => items.value.length);
const percent = computed(() => total.value ? Math.round((completedCount.value / total.value) * 100) : 0);
const currentNumber = computed(() => items.value.find(item => item.section.id === props.currentSectionId)?.number ?? null);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("h3", _hoisted_2, _toDisplayString(_unref(tl)('your_progress')), 1),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        (_openBlock(), _createElementBlock("svg", _hoisted_5, [
          _createElementVNode("circle", {
            cx: "42",
            cy: "42",
            r: RADIUS,
            class: "lp-progress__ring-track"
          }),
          _createElementVNode("circle", {
            cx: "42",
            cy: "42",
            r: RADIUS,
            class: "lp-progress__ring-value",
            "stroke-dasharray": CIRCUMFERENCE,
            "stroke-dashoffset": CIRCUMFERENCE * (1 - _unref(percent) / 100)
          }, null, 8, _hoisted_6)
        ])),
        _createElementVNode("span", null, _toDisplayString(_unref(percent)) + "%", 1)
      ]),
      _createElementVNode("div", null, [
        _createElementVNode("p", _hoisted_7, _toDisplayString(_unref(currentNumber) ? _unref(tl)('section_of', { current: _unref(currentNumber), total: _unref(total) }) : _unref(tl)('path_completed')), 1),
        _createElementVNode("p", _hoisted_8, _toDisplayString(_unref(tl)('sections_completed', { done: _unref(completedCount), total: _unref(total) })), 1)
      ])
    ]),
    _createElementVNode("ul", _hoisted_9, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(items), (item) => {
        return (_openBlock(), _createElementBlock("li", {
          key: item.section.id
        }, [
          _createElementVNode("button", {
            type: "button",
            class: _normalizeClass(["lp-progress__item", {
            'lp-progress__item--current': item.section.id === __props.currentSectionId,
            'lp-progress__item--completed': item.completed,
          }]),
            onClick: ($event: any) => (emit('select', item.section.id))
          }, [
            _createElementVNode("span", _hoisted_11, [
              (item.completed)
                ? (_openBlock(), _createElementBlock("i", _hoisted_12))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("span", _hoisted_13, _toDisplayString(_unref(tl)('section_label')) + " " + _toDisplayString(item.number) + " — " + _toDisplayString(item.section.title), 1),
            _createElementVNode("span", _hoisted_14, _toDisplayString(item.done) + "/" + _toDisplayString(item.total), 1)
          ], 10, _hoisted_10)
        ]))
      }), 128))
    ])
  ]))
}
}

})